module.exports = __webpack_public_path__ + "img/interface OneB Studio_3.c895dd71.jpg";